(() => {
    const SELECTORS = {
        OPTION_HIDDEN: 'option--hidden',
        SET_HIDDEN: 'product-order-set--hidden',
        SET: 'product-order-set',
        MARK_SELECTED: 'mark--selected-js',
        OPTIONGROUP: 'optiongroup',
    };

    const onInputChange = (inputs) => {
        inputs.forEach((input) => {
            let checked = input.checked;

            //todo: disabled bug
            // if (input.hasAttribute('data-disabled')) {
            //     return;
            // }
            if (input.tagName === 'SELECT') {
                const numericValue = parseInt(input.value);
                checked = numericValue > 0 || !!input.value;
            }

            input.closest('label').classList.toggle(SELECTORS.MARK_SELECTED, checked);
        });
    };

    // Radio inputs must also be able to be unchecked, therefore we store the state separately.
    const toggleRadio = (radioInput, inputGroup) => {
        const inputState = radioInput.dataset.checked === 'true';
        if (radioInput.dataset.required !== undefined && inputState) {
            return;
        }

        radioInput.dataset.checked = inputState ? 'false' : 'true';
        inputGroup.forEach((otherInput) => {

            if (otherInput.checked && radioInput.id !== otherInput.id) {
                otherInput.checked = false;
                otherInput.dataset.checked = 'false';
                otherInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        setTimeout(() => {
            radioInput.checked = !inputState;
            onInputChange(inputGroup);

            // Trigger the form change event manually as we prevented the event from bubbling
            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    const marksHighlightFunction = () => {
        const form = document.querySelector('.product-order form');
        const marks = document.querySelectorAll('.marks-js');

        if (!form || !marks) return;

        marks.forEach((mark) => {
            const input = mark.querySelector('input, select');
            if (mark.parentElement.classList.contains('optiongroup')) {
                const optionGroup = mark.parentElement;
                const siblings = optionGroup.querySelectorAll('input, select');

                input.addEventListener('change', () => onInputChange(siblings));

                if (input.type === 'radio') {
                    input.dataset.checked = input.checked ? 'true' : 'false';

                    const inputLabel = input.parentElement;
                    inputLabel.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleRadio(input, siblings);
                    });
                }
            } else {
                input.addEventListener('change', () => onInputChange([input]));
            }
        });

        form.classList.add('initialized');
    };

    const refreshSetVisibility = (option) => {
        const optionSet = option.closest('.' + SELECTORS.SET);

        // Check whether the group has to be toggled as all children are hidden.
        const inputs = optionSet.querySelectorAll('input, select');
        const hiddenOptions = optionSet.querySelectorAll(`.${SELECTORS.OPTION_HIDDEN} input, .${SELECTORS.OPTION_HIDDEN} select`);
        // Option groups count as option but don't have their own input, so we have to check
        // whether there are more or equal hidden options than inputs
        optionSet.classList.toggle(SELECTORS.SET_HIDDEN, inputs.length <= hiddenOptions.length);
    };

    // Initialises toggling of fields and sets depending on other fields
    const initRequiredFieldDependencies = () => {
        const optionElements = document.querySelectorAll('[data-option-id]');
        const options = {};
        const optionDependencies = {};

        // Store elements by their option id and create dependency map
        optionElements.forEach((option) => {
            const { optionId, requiredOptionId } = option.dataset;
            options[optionId] = {
                element: option,
                requiredOptionId: requiredOptionId,
            };

            if (requiredOptionId) {
                if (!optionDependencies[requiredOptionId]) {
                    optionDependencies[requiredOptionId] = [];
                }
                optionDependencies[requiredOptionId].push(optionId);
            }
        });

        const toggleOptions = (dependentOptionIds, checked, value) => {

            dependentOptionIds.forEach((dependentOptionId) => {
                const element = options[dependentOptionId].element;

                // Special handling for radio selects
                if (element.dataset.requiredOptionValue) {
                    checked = checked && value === element.dataset.requiredOptionValue;
                }

                element.classList.toggle(SELECTORS.OPTION_HIDDEN, !checked);

                // enable/disable frontend check for required fields if visable/hidden
                element.querySelectorAll('input, select').forEach((input) => {
                    if (input.getAttribute('data-required') !== null) {
                        if (checked) {
                            input.setAttribute('required','required');
                        }
                        else {
                            input.removeAttribute('required');
                        }
                    }
                });

                // Uncheck fields if necessary -> updates the shopping cart
                if (!checked) {
                    element.querySelectorAll('input, select').forEach((input) => {
                        let changed;

                        //todo: disabled bug
                        // if (input.hasAttribute('data-disabled')) {
                        //     disabled = true;
                        //     return;
                        // }
                        if (input.type === 'radio' || input.type === 'checkbox') {
                            changed = input.checked || input.dataset.checked === 'true';
                            input.checked = false;
                            input.dataset.checked = 'false';
                        } else {
                            changed = input.value !== '';
                            //input.value = '';
                        }
                        if (changed) {
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                }
                refreshSetVisibility(element);
            });
        };

        // Add event listener to toggle depending fields
        Object.keys(optionDependencies).forEach((optionId) => {
            const dependentOptionIds = optionDependencies[optionId];
            const optionIdParts = optionId.split('.');

            // If we have more than 2 parts the last one is the value of a selection
            // FIXME: Make this more explicit and reliable somehow
            if (!options[optionId] && optionIdParts.length > 2) {
                optionId = optionIdParts[0] + '.' + optionIdParts[1];
            }

            if (!options[optionId]) {
                console.error(optionId, 'missing in options');
                return;
            }

            const { element } = options[optionId];
            const elementInputs = element.querySelectorAll('input');
            elementInputs.forEach((input) => {
                input.addEventListener('change', (e) => {
                    toggleOptions(dependentOptionIds, e.target.checked, e.target.value);
                });
            });

            const elementSelect = element.querySelectorAll('select');
            elementSelect.forEach((input) => {
                input.addEventListener('change', (e) => {
                    toggleOptions(dependentOptionIds, true, e.target.value);
                });
            });
        });
    };

    const initResetErrorState = () => {
        const inputs = document.querySelectorAll('input.error');

        const removeErrorClass = (e) => {
            e.target.classList.remove('error');
            e.target.removeEventListener('change', removeErrorClass);
        };

        inputs.forEach((input) => input.addEventListener('change', removeErrorClass));
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        marksHighlightFunction();
        initRequiredFieldDependencies();
        initResetErrorState();
    });
})();
